import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { userInfoSync } from 'hub-http/userInfo';
import I18n from 'I18n';
import ImageUploadWithIframePicker from 'FileManagerLib/picker/ImageUploadWithIframePicker';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import ReadOnlyImageUpload from './ReadOnlyImageUpload';
import FileManager from '../../components/FileManager';
import { getAspectRatio } from '../utils/dimensionsUtils';
import DimensionsField from './DimensionsField';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VAST_LOGO_REGEX = /\/hs\/hsstatic\/content_shared_assets\/static-[^]+\/img\/vast.png/;
function I18nText(messageKey) {
  return I18n.text(`knowledgeContentUI.templateEditor.fields.${messageKey}`);
}
function ImageField(props) {
  const {
    _defaultHeight: defaultHeight = 0,
    _maxHeight: maxHeight = 0,
    onFieldChange,
    readOnly,
    size,
    value = {}
  } = props;
  const [imageFieldState, setImageFieldState] = useState({
    aspectRatio: value.aspectRatio || 0,
    disabled: !value.src || false,
    height: value.height || 0,
    maxWidth: Math.round(maxHeight * (value.aspectRatio || 0)),
    naturalHeight: value.height || 0,
    naturalWidth: (value.height || 0) * (value.aspectRatio || 0),
    src: VAST_LOGO_REGEX.test(value.src || '') ? undefined : value.src || undefined,
    linkToUrl: value.linkToUrl || '',
    width: Math.round((value.height || 0) * (value.aspectRatio || 0))
  });
  const {
    src,
    linkToUrl
  } = imageFieldState;
  const handleUpdateFieldState = useCallback(partialImageFieldState => {
    const updatedState = Object.assign({}, imageFieldState, partialImageFieldState);
    onFieldChange(updatedState);
    setImageFieldState(updatedState);
  }, [onFieldChange, setImageFieldState, imageFieldState]);
  const handleFileUploadChange = (__url, imageFile) => {
    const imageUrl = imageFile ? imageFile.url : undefined;
    if (imageUrl !== imageFieldState.src) {
      if (imageFile) {
        const newNaturalHeight = imageFile.height;
        const newNaturalWidth = imageFile.width;
        const newAspectRatio = getAspectRatio(newNaturalWidth, newNaturalHeight);
        handleUpdateFieldState({
          aspectRatio: newAspectRatio,
          disabled: false,
          height: defaultHeight,
          maxWidth: Math.round(maxHeight * newAspectRatio),
          naturalHeight: newNaturalHeight,
          naturalWidth: newNaturalWidth,
          linkToUrl: '',
          src: imageUrl,
          width: Math.round(defaultHeight * newAspectRatio)
        });
      } else {
        handleUpdateFieldState({
          aspectRatio: undefined,
          disabled: true,
          height: undefined,
          naturalHeight: undefined,
          naturalWidth: undefined,
          maxWidth: undefined,
          src: undefined,
          width: undefined,
          linkToUrl: ''
        });
      }
    }
  };
  const handleURLChange = ({
    currentTarget: {
      value: updatedUrl
    }
  }) => {
    handleUpdateFieldState({
      linkToUrl: updatedUrl
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [readOnly ? /*#__PURE__*/_jsx(ReadOnlyImageUpload, {
      imageUrl: src || undefined
    }) : /*#__PURE__*/_jsx(FileManager, {
      auth: userInfoSync(),
      children: /*#__PURE__*/_jsx(ImageUploadWithIframePicker, {
        imageUrl: src,
        onChange: handleFileUploadChange,
        pickerType: "SIDE_MODAL",
        size: size
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      className: "m-top-0",
      children: /*#__PURE__*/_jsx(DimensionsField, {
        defaultHeight: defaultHeight,
        maxHeight: maxHeight,
        imageFieldState: imageFieldState,
        setImageFieldState: handleUpdateFieldState
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      label: I18nText('logoURL.label'),
      children: /*#__PURE__*/_jsx(UITextInput, {
        disabled: readOnly || !src,
        value: linkToUrl,
        onChange: handleURLChange
      })
    })]
  });
}
ImageField.propTypes = {
  _defaultHeight: PropTypes.number,
  _maxHeight: PropTypes.number,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  size: PropTypes.string,
  value: PropTypes.shape({
    aspectRatio: PropTypes.number,
    height: PropTypes.number,
    linkToUrl: PropTypes.string,
    src: PropTypes.string
  })
};
export default ImageField;